import { Typography, Button, Box } from '@mui/material';
import { formatDateString } from '../../utils';
import { memo, useCallback, useMemo } from 'react';
import { BUTTON_DISCOVER_MORE } from '../../constants';
import { IAppointment } from '../../constants/types';

import imgEyeSurgery from '/images/eye-surgery.svg';
const AppointmentCard = ({
  appointment,
  onDetailsClick,
}: {
  appointment: IAppointment;
  onDetailsClick: (id: number) => void;
}) => {
  const { date, sub_care_type_name, id } = appointment || {};

  const formattedAppointmentDate = useMemo(
    () => formatDateString(date),
    [date]
  );

  const handleDiscoverMore = useCallback(() => {
    onDetailsClick(id);
  }, [id, onDetailsClick]);

  const imgEyeSurgeryStyle = {
    width: '93px',
    height: 'auto',
    right: '24px',
    bottom: '18px',
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <Typography variant="subtitle1" color="primary.light" sx={{ mb: 2.5 }}>
        {formattedAppointmentDate}
      </Typography>
      <Typography
        variant="h4"
        sx={{ maxWidth: '72%', color: 'common.white', mb: 3 }}
      >
        {sub_care_type_name}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        size="small"
        sx={{ width: 182 }}
        onClick={handleDiscoverMore}
      >
        {BUTTON_DISCOVER_MORE}
      </Button>
      <img
        style={imgEyeSurgeryStyle}
        src={imgEyeSurgery}
        alt="eye surgery"
        className="position-absolute"
      />
    </Box>
  );
};

export default memo(AppointmentCard);
